'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case SET_SONGS_FILTER:
      {
        return (0, _extends3.default)({}, state, {
          kw: action.kw
        });
      }
    case UPDATE_CHECKED_SONGS:
      {
        return (0, _extends3.default)({}, state, {
          checkedSongs: action.checkedSongs
        });
      }
    default:
      return reducer(state, action);
  }
};

exports.isSongsLoaded = isSongsLoaded;
exports.loadSongs = loadSongs;
exports.setSongsFilter = setSongsFilter;
exports.updateCheckedSongs = updateCheckedSongs;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_SONGS_FILTER = 'songs/SET_SONGS_FILTER'; /* Songs redux reducer and action creators */

var UPDATE_CHECKED_SONGS = 'songs/UPDATE_CHECKED_SONGS';

var loadReducer = (0, _loadReducer2.default)('songs', {
  songs: { init: { tracks: {} } }
});

var reducer = loadReducer.reducer,
    constantsByKey = loadReducer.constantsByKey;


var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
  songsPopupVisible: false,
  kw: '',
  checkedSongs: {}
});

function isSongsLoaded() {
  return function (dispatch, getState) {
    return (0, _get3.default)(getState(), 'songs.songsLoaded');
  };
}

function loadSongs() {
  return {
    types: constantsByKey.songs,
    promise: function promise(client) {
      return client.post('viewer_wa/playlists');
    }
  };
}

function setSongsFilter(_ref) {
  var kw = _ref.kw;

  return {
    type: SET_SONGS_FILTER,
    kw: kw
  };
}

function updateCheckedSongs(checkedSongs) {
  return {
    type: UPDATE_CHECKED_SONGS,
    checkedSongs: checkedSongs
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/songs.js
// module id = 266
// module chunks = 1